import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { Col, Row, Card } from 'reactstrap';

const moment = require('moment');

const PatrolReport = ({ reports, trackerId, reporters, callerId }) => {
    //console.log("Patrol Report > reports: ", reports)
    //console.log("Patrol Report > trackerId : ", trackerId)

    return reports.map(e => {
        return (
            <Card key={e.id} className='p-3 m-3'>
                <Row className='ml-1'>
                    <Col>
                        <span className='h6 font-italic'>
                            <Link
                                to={{
                                    pathname: '/touring/history/details/report',
                                    report: e,
                                    reporters: reporters,
                                    callerId: callerId,
                                    state: { ...trackerId }
                                }}
                            >
                                {e.issue}
                            </Link>
                            <div>
                                <small className='text-muted'>
                                    {moment(e.createdAt).format('YYYY/MM/DD h:mm:ss A')}
                                </small>
                            </div>
                            <div className='mt-2'>
                                <small className='border-l-2 pl-2'>{e.detail}</small>
                            </div>
                        </span>
                    </Col>
                </Row>
            </Card>
        );
    });
};

PatrolReport.propTypes = {
    reports: PropTypes.array,
    detail: PropTypes.object
};

export default PatrolReport;



// WEBPACK FOOTER //
// ./src/components/blocks/PatrolReport/PatrolReport.js